import axios from "axios";
import { API_BASE_URL } from "../utils/config";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { firestore } from "../../services/firebase";

// Create a new bill type
const createBillType = async (user, billTypeData) => {
  try {
    if (user) {
      const idTokenResult = await user.getIdTokenResult();
      if (
        idTokenResult.claims.admin === true ||
        idTokenResult.claims.subAdmin === true
      ) {
        const idToken = await user.getIdToken();
        const response = await axios.post(
          `${API_BASE_URL}api/bill/billTypes`,
          billTypeData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${idToken}`,
            },
          }
        );
        return response;
      } else {
        throw {
          response: {
            data: {
              message: "User is not authorized to create bill types.",
              type: "error",
            },
          },
        };
      }
    }
  } catch (error) {
    throw error;
  }
};

// Update a bill type
const updateBillType = async (user, billTypeId, billTypeData) => {
  try {
    if (!user) {
      return null;
    }

    const idTokenResult = await user.getIdTokenResult();
    if (
      idTokenResult.claims.admin === true ||
      idTokenResult.claims.subAdmin === true
    ) {
      const idToken = await user.getIdToken();
      const response = await axios.put(
        `${API_BASE_URL}api/bill/billTypes/${billTypeId}`,
        billTypeData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
      return response;
    } else {
      throw {
        response: {
          data: {
            message: "User is not authorized to update bill types.",
            type: "error",
          },
        },
      };
    }
  } catch (error) {
    throw error;
  }
};

// Delete a bill type
const deleteBillType = async (user, billTypeId) => {
  try {
    if (!user) {
      return null;
    }

    const idTokenResult = await user.getIdTokenResult();
    if (
      idTokenResult.claims.admin === true ||
      idTokenResult.claims.subAdmin === true
    ) {
      const idToken = await user.getIdToken();
      const response = await axios.delete(
        `${API_BASE_URL}api/bill/billTypes/${billTypeId}`,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
      return response;
    } else {
      throw {
        response: {
          data: {
            message: "User is not authorized to delete bill types.",
            type: "error",
          },
        },
      };
    }
  } catch (error) {
    throw error;
  }
};

// Get bill types for a specific branch (read operation - can be done directly from Firestore)
const getBillTypes = (branchId, setData) => {
  const billTypesCollection = collection(firestore, "BillTypes");
  const q = query(billTypesCollection, where("branchId", "==", branchId));

  return onSnapshot(q, (querySnapshot) => {
    const billTypes = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setData(billTypes);
  });
};

export { createBillType, updateBillType, deleteBillType, getBillTypes };
